(function () {
  // Guard against the script being included once per section instance
  if (window.RangeFeatures) return;

  function RangeFeatures(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('.js-range-features-tab'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('.js-range-features-panel'));

    if (!this.tabs.length) return;

    this.bindTabs();
  }

  RangeFeatures.prototype.bindTabs = function () {
    var self = this;

    this.tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        self.select(index);
      });

      tab.addEventListener('keydown', function (event) {
        var lastIndex = self.tabs.length - 1;
        var target = null;

        switch (event.key) {
          case 'ArrowRight':
            target = index === lastIndex ? 0 : index + 1;
            break;
          case 'ArrowLeft':
            target = index === 0 ? lastIndex : index - 1;
            break;
          case 'Home':
            target = 0;
            break;
          case 'End':
            target = lastIndex;
            break;
          default:
            return;
        }

        event.preventDefault();
        self.select(target);
        self.tabs[target].focus();
      });
    });
  };

  RangeFeatures.prototype.select = function (index) {
    this.tabs.forEach(function (tab, tabIndex) {
      var isActive = tabIndex === index;
      var panel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      if (panel) panel.hidden = !isActive;
    });
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.js-range-features');

    Array.prototype.forEach.call(roots, function (root) {
      if (root.rangeFeatures) return;
      root.rangeFeatures = new RangeFeatures(root);
    });
  }

  window.RangeFeatures = RangeFeatures;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: re-init when the section is re-rendered, and show the selected swatch's cards
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.closest('.js-range-features-tab');
    if (!tab) return;

    var root = tab.closest('.js-range-features');
    var instance = root && root.rangeFeatures;
    if (!instance) return;

    instance.select(instance.tabs.indexOf(tab));
  });
})();
